import React from 'react';
import { FsmManagerReviewPage } from './FsmManagerReviewPage';
import { FsmTechnicianTicketPage } from './FsmTechnicianTicketPage';
import { hasCanonicalRole } from '../../../lib/auth';

/**
 * Role-based ticket detail entry.
 * Canonical roles come from login (`empobj.canonical_role_name`) via sessionDB.
 *
 * Technician → technician ticket screen.
 * Customer_Service / Service Manager / Manager / others → manager review screen
 * (Customer Service verifies Closure_Requested; Service Manager closes Closure_Verified).
 * Never redirect back to the list — that looked like a page refresh on row click.
 */
export function FsmTicketDetailContainer() {
  if (hasCanonicalRole('technician')) {
    return <FsmTechnicianTicketPage />;
  }

  return <FsmManagerReviewPage />;
}
